import { ColumnDef } from "@tanstack/react-table";

// A column's stable id: an explicit `id`, otherwise its `accessorKey`
// (TanStack derives the runtime column id the same way). Shared by the Table
// (to skip non-hideable columns) and TableColumnsToggle (to list them) so the
// derivation stays in one place.
export const getColumnId = <T>(column: ColumnDef<T>): string | undefined => {
  const id =
    column.id ?? (column as { accessorKey?: string | number }).accessorKey;

  return id === undefined ? undefined : String(id);
};

export const isColumnHideable = <T>(column: ColumnDef<T>): boolean =>
  column.enableHiding !== false;
